<template>
    <div class="modal-card card">
        <div class="card-header">
            <h4 class="card-header-title">
                Job Rerun
                <span class="fa fa-circle-info text-muted" title="Rerun a failed/cancelled job execution"
                    data-bs-toggle="tooltip" data-bs-placement="right"></span>
            </h4>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="card-body">
            <div class="list-group list-group-flush">
                <div class="list-group-item">
                    <div class="row align-items-center">
                        <div class="col">
                            <span class="mb-0">Image</span>
                            <!-- required field -->
                            <span class="text-danger">*</span>
                            <span class="fa fa-circle-info text-muted" title="Docker image url stored in an aws ECR or google GCR"
                                data-bs-toggle="tooltip" data-bs-placement="right" :style="{ marginLeft: '0.2rem' }"></span>
                        </div>
                        <div class="col-9">
                            <input type="text" class="form-control" v-model="image"
                                placeholder="Enter image" style="width: 100%" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card-footer d-flex justify-content-between align-items-center">
            <div class="text-danger">
                {{ error }}
            </div>
            <button class="btn btn-primary" @click="reRunJob"
                :disabled="running || !data.sandboxName || !data.jobName || !data.executionId || !image">
                <div v-if="running" class="spinner-border spinner-border-sm" role="status"
                    :style="{ height: '1em', width: '1em' }">
                    <span class="visually-hidden">Loading...</span>
                </div>
                Rerun Job
            </button>
        </div>
    </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
    name: "ReRunJob",
    data() {
        return {
            data: null,
            image: "",
            running: false,
            error: "",
        }
    },
    props: {
        modalData: {
            type: [Object, Array, String],
        }
    },
    methods: {
        ...mapActions({
            reRunSandboxJob: "sandbox/reRunSandboxJob",
        }),
        async reRunJob() {
            this.running = true;
            this.error = "";
            let payload = {};
            if (this.image) payload.image = this.image;

            await this.reRunSandboxJob({
                sandboxName: this.data.sandboxName,
                jobName: this.data.jobName,
                executionId: this.data.executionId,
                payload: payload,
            }).then((response) => {
                // reroute to the corresponding job execution details page
                const executionId = response.data.execution_id;
                this.$store.dispatch('hideModal');
                this.$router.push({
                    name: this.data.routeNameAfterReRun,
                    params: {
                        cid: this.$store.state.currentClient.cid,
                        sandboxId: this.data.sandboxName,
                        jobId: this.data.jobName,
                        executionId: executionId,
                    },
                });
            }).catch((error) => {
                console.error("Error rerunning job: ", error);
                this.error = error.response?.data?.error || error.message || "Something went wrong while rerunning the job. Please contact support.";
            }).finally(() => {
                this.running = false;
            });
        }
    },
    beforeMount() {
        this.data = JSON.parse(JSON.stringify(this.modalData));
    }
}
</script>

<style scoped>
</style>